import { useEffect, useState } from "react";
import GetIcon from '../../../../utils/Icon';
import { useLocation, useNavigate } from "react-router-dom";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Table from "./Table";
import printerimg from "../../../../assets/print.png"
import {
    useGetPurchaseOrderByNameMutation, useGetVendorAddressListMutation,
    useGetVendorListMutation, usePostItemListMutation,
} from "../../../../store/api/purchaseorderapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout"
import { useGetDoctypePrintTypeQuery } from "../../../../store/api/globalapi";
import PrintModal from "../../../../Core/Print/PrintModal";
import Attachment from "../../../../utils/Attachment";
function Viewpurchase() {
    const nvg = useNavigate()
    const [tab, settab] = useState(1)
    const [podate, setpodate] = useState('')
    const [podata, setpodata] = useState('')
    const [showPrintModal, setShowPrintModal] = useState(false);
    const location = useLocation();
    const [status, setStatus] = useState('')
    const PurchaseData = location.state?.PurchaseId;
    const [error, setError] = useState('');
    const [AttachmentsList, setAttachmentsList] = useState([]);
    const [shipping_address, setShipping_address] = useState('');
    const [allitems, setAllitems] = useState([])
    const [Ptype, setPtype] = useState('Drop Shipping Format');
    const [showError, setShowError] = useState(false);
    const [vendor_list, setvendor_list] = useState([]);
    const [select_vendor, setselect_vendor] = useState("");
    const [required_date, setrequired_date] = useState("");
    const [selected_item_data, setselected_item_data] = useState([]);
    const [select_vendor_address, setselect_vendor_address] = useState({});
    const [vendor_address_list, setvendor_address_list] = useState([]);
    const [asn_inclusion, setasn_inclusion] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({
        vendor: false,
        vendor_address: false,
        required_date: false,
        items: false
    });
    const [getvendor_list] = useGetVendorListMutation();
    const [getvendor_address_list_data] = useGetVendorAddressListMutation();
    const { data: printFormatType, isLoading: printFormatTypeLoader } = useGetDoctypePrintTypeQuery({ "filters": '[["Print Format","doc_type","=","Purchase Order"]]' });
    useEffect(() => {
        if (!printFormatTypeLoader) {
            setPtype(printFormatType?.data?.[0]?.name);
        }
    }, [printFormatType, printFormatTypeLoader])


    const [getitem_list_data] = usePostItemListMutation()
    const [activityboll, setactivityboll] = useState(false)
    const getVendorAndWarehouse = async () => {
        const venderApiData = await getvendor_list()
        setvendor_list(venderApiData.data.result);
    }
    const getVendor_Address = async () => {
        try {
            const vendorAddressApiData = await getvendor_address_list_data({ vendor: select_vendor })
            setvendor_address_list(vendorAddressApiData.data.result);
            setselect_vendor_address(vendorAddressApiData.data.result?.[0])
        } catch (error) {
            // console.log("check error", error)
        }
    }
    const [getPurchaseOrderByName] = useGetPurchaseOrderByNameMutation();

    useEffect(() => {
        if (PurchaseData) {
            getPurchaseOrderByName({ doctype: 'Purchase Order', name: PurchaseData })
                .unwrap()
                .then((response) => {
                    setpodata(response)
                    setactivityboll(true)
                    setselect_vendor(response.message.supplier_name)
                    setpodate(response.message.transaction_date)
                    setrequired_date(response.message.schedule_date)
                    setShipping_address(response.message.shipping_address)
                    setAllitems(response.message.items)
                    setStatus(response.message.wms_status == null ? response.message.status : response.message.wms_status)
                    setasn_inclusion(response.message?.custom_include_in_asn == 1);

                })
                .catch((err) => {
                    console.error('API Error:', err);
                });
        } else {
            console.warn('No PurchaseData found in location state');
        }
    }, [PurchaseData, getPurchaseOrderByName]);


    useEffect(() => {
        getVendor_Address()
    }, [select_vendor])

    useEffect(() => {
        getVendorAndWarehouse()
    }, [])

    const handleEdit = async (id) => {
        nvg(`/inbound/purchaseorder/duplicate-purchase-order`, { state: { PurchaseId: PurchaseData } });
    };

    return (
        <FormLayout
            title="View Purchase Order"
            breadcrumbs={[
                { label: "Inbound" },
                { label: "Purchase Order List", url: "/inbound/purchaseorder/purchase-orders" }
            ]}
            status={status}
            actionButtons={
                <>
                    <Button
                        onClick={handleEdit}
                        className="createbtn d-flex"
                        style={{ gap: '2px', height: '28px' }}
                        iconName="GrCopy"
                        iconSize={12}
                    >
                        Duplicate
                    </Button>
                    <p className="p-0 m-0">
                        <img src={printerimg}
                            onClick={() => setShowPrintModal(true)}
                            className="px-2" style={{ width: '35px', cursor: 'pointer' }} alt="404" />
                    </p>

                </>
            }
        >
            <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                <button className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </button>
                            </li>
                            <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                                <button className={tab == 2 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                                    Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </button>
                            </li>
                        </ul>
                        <Attachment
                            doctype="Purchase Order"
                            docname={PurchaseData}
                            attachments={AttachmentsList}
                            setAttachments={setAttachmentsList}
                        />
                        {/* <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                            <span style={{ position: 'relative', top: '-1px' }}>
                                <GetIcon iconName="CgAttachment" size={12} />
                            </span>
                            <span className=" fw-semibold" style={{ color: "#391F84" }}>
                                Attachments
                            </span>
                        </div> */}
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
                    {tab != 1 ? "" : <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1
                            activityboll={activityboll}
                            status={status} purchasename={PurchaseData} ApiData={podata}
                            vendor={{ vendor_list: vendor_list, setselect_vendor: setselect_vendor, select_vendor: select_vendor, Error: fieldErrors.vendor }}
                            selectedAddress={{ list: vendor_address_list, currentAddress: select_vendor_address, Error: fieldErrors.vendor_address }}
                            required_date={{ setrequired_date: setrequired_date, required_date: required_date, Error: fieldErrors.required_date }}
                            podate={{ podate: podate, setpodate: setpodate }}
                            setasn_inclusion={setasn_inclusion}
                            asn_inclusion={asn_inclusion}


                        />
                    </div>}
                    {tab != 1 ? "" : <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
                        <div className="d-flex pb-2" style={{ gap: '5px' }}>
                            <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {selected_item_data.length}</span></p>
                            <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {selected_item_data.reduce((total, item) => { return total + Number(item.quantity); }, 0)}</span></p>
                            {/* <p className="ReceivedQty" style={{ display: po_response.result ? '' : 'none' }}>Received Quantity -  <span style={{ color: '#EC642A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}</span></p> */}
                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p className="" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>

                        <Table status={status} setselected_item_data={setselected_item_data} allitems={allitems} list_data={getitem_list_data} />

                        <div className=" pb-2" style={{ marginTop: 'auto' }} >
                            <div className="row mt-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <div style={{ width: '20%' }}>
                                    <p className="TotalQtywithoutBg">
                                        Ordered Quantity -
                                        <span style={{ color: '#EC642A' }}>
                                            {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}
                                        </span>
                                    </p>
                                </div>

                                <div style={{ width: '18%' }}>
                                    <p className="NoOfLinewithoutBg">
                                        Total Value -
                                        <span style={{ color: '#FF5969' }}>
                                            {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}
                                        </span>
                                    </p>
                                </div>

                                <div style={{ width: '24%' }}>
                                    <p className="NoOfLinewithoutBg">
                                        Tax Type -
                                        <span style={{ color: '#C40AB8' }}>
                                            {podata.message?.taxes.length == 0 ? '' : podata.message?.taxes.reduce((acc, curr) => {
                                                if (!acc.includes(curr.description)) {
                                                    acc.push(curr.description);
                                                }
                                                return acc;
                                            }, []).join(', ')}
                                        </span>
                                    </p>
                                </div>

                                <div style={{ width: '15%' }}>
                                    <p className="NoOfLinewithoutBg">
                                        Tax -
                                        <span style={{ color: '#2563EB' }}>
                                            {podata.message?.total_taxes_and_charges}
                                        </span>
                                    </p>
                                </div>

                                <div style={{ width: '22%' }}>
                                    <p className="NoOfLinewithoutBg">
                                        Final Total -
                                        <span style={{ color: '#16A34A' }}>
                                            {/* {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)} */}
                                            {podata.message?.grand_total}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {tab != 2 ? "" : <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px' }}>
                        <Tab2 vendor_address={{ vendor_address_list: vendor_address_list, setselect_vendor_address: setselect_vendor_address, currentAddress: select_vendor_address }} shippingAddr={{ setShipping_address: setShipping_address, currentAddress: shipping_address }} />
                    </div>}
                </div>
            </div>


            {showPrintModal && (
                <PrintModal
                    onClose={() => setShowPrintModal(false)}
                    documentId={PurchaseData}
                    doctype="Purchase Order"
                    title="Print Purchase Order"
                />
            )}

            <ApiResponseBox
                show={showError}
                errorMessage={error}
                onClose={() => setShowError(false)}
            />
        </FormLayout>
    )
}

export default Viewpurchase
